module.exports = __webpack_public_path__ + "jtails-build/img/store-default-Image@2x.bf8defb4.png";